import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "img-pushpin-9", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { stroke: "currentColor", d: "m6.5 3.207.44.44c.358.358.56.845.56 1.353a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5c0-.508.202-.995.56-1.354l.44-.439V.5h4ZM7.5.5Z" }),
        React.createElement("path", { fill: "currentColor", d: "M4 6h1v2.5a.5.5 0 0 1-1 0V6Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
